// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
export const RECORD_LINK_SOURCE_TYPES = [
    'form_instance',
    'vehicle_monitoring_device',
    'vehicle_monitoring_device_event',
    'vendor_questionnaire',
];
export const RECORD_LINK_TARGET_TYPES = [
    'vendor',
    'vendor_questionnaire',
    'ai_system',
    'ai_system_version',
    'ai_classification_run',
    'processing_activity',
    'dpia',
    'incident',
    'evidence',
    'data_map_system',
    'vehicle_monitoring_device',
];
//# sourceMappingURL=record-links.js.map